import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";
import  IconZoomPermissionError  from "../../../components/icons/IconZoomPermissionError";

export default function ShowPermissionError({ zoomLogin ,title,description}) {

  return (
    <Box
      sx={{
        height: "100%",
        px: 2,
        backgroundColor: "white",
        opacity: 0.9,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow:
          "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)",
      }}
    >
      <Stack direction="column" alignItems="center" >
        <IconZoomPermissionError />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        > 
          <Typography
            variant="h6"
            component="div"
            textAlign="center"
            fontSize="16px"
          >
           {title}
          </Typography>
          <Typography variant="body2" textAlign="center" fontSize="15px">
          {description}
          </Typography>
        </Box>

        <Box sx={{ width: "100%", textAlign: "center",mt:1 }}>
          <Button
            onClick={zoomLogin}
            variant="contained"
            sx={{
              bgcolor: "#006AC6",
              "&:hover": { bgcolor: "#0053a0" },
            }}
          >
            Connect Zoom
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
